<!-- @format -->

<main class="login-error-page" role="main">
  <fudis-heading [level]="1">{{ "LOGIN_ERROR.PAGE_TITLE" | translate }}</fudis-heading>

  <section class="login-error-page__box" [attr.aria-labelledby]="'login-error-bucket-title'">
    <fudis-heading [level]="2" [align]="'center'" id="login-error-bucket-title">{{ titleKey | translate }}</fudis-heading>
    <fudis-body-text [variant]="'lg-regular'">{{ descriptionKey | translate }}</fudis-body-text>
    <fudis-button [label]="'LOGIN_ERROR.ACTION' | translate" [variant]="'primary'" (handleClick)="onPrimaryAction()"></fudis-button>
  </section>

  @if (hasDiagnostics) {
    <details class="login-error-page__diagnostics">
      <summary>
        <fudis-body-text [variant]="'lg-regular'">{{ "LOGIN_ERROR.DIAGNOSTICS_TOGGLE" | translate }}</fudis-body-text>
      </summary>

      <dl>
        @if (diagnostics.now) {
          <dt
            ><fudis-body-text [variant]="'lg-regular'">{{ "LOGIN_ERROR.DIAGNOSTICS_TIME" | translate }}</fudis-body-text></dt
          >
          <dd
            ><fudis-body-text [variant]="'lg-regular'">{{ diagnostics.now }}</fudis-body-text></dd
          >
        }
        @if (diagnostics.entityID) {
          <dt
            ><fudis-body-text [variant]="'lg-regular'">{{ "LOGIN_ERROR.DIAGNOSTICS_IDP" | translate }}</fudis-body-text></dt
          >
          <dd
            ><fudis-body-text [variant]="'lg-regular'">{{ diagnostics.entityID }}</fudis-body-text></dd
          >
        }
        @if (diagnostics.statusFull) {
          <dt
            ><fudis-body-text [variant]="'lg-regular'">{{ "LOGIN_ERROR.DIAGNOSTICS_STATUS" | translate }}</fudis-body-text></dt
          >
          <dd
            ><fudis-body-text [variant]="'lg-regular'">{{ diagnostics.statusFull }}</fudis-body-text></dd
          >
        }
        @if (diagnostics.errorType) {
          <dt
            ><fudis-body-text [variant]="'lg-regular'">{{ "LOGIN_ERROR.DIAGNOSTICS_ERROR_TYPE" | translate }}</fudis-body-text></dt
          >
          <dd
            ><fudis-body-text [variant]="'lg-regular'">{{ diagnostics.errorType }}</fudis-body-text></dd
          >
        }
      </dl>

      <fudis-body-text [variant]="'lg-regular'" class="login-error-page__diagnostics-note">
        {{ "LOGIN_ERROR.DIAGNOSTICS_NOTE" | translate }}
      </fudis-body-text>
    </details>
  }
</main>
